import { useEffect } from "react";
import '../../styles/Login.css';

const SWIFTBOARD_URL = process.env.REACT_APP_FRONTEND_SWIFTBOARD_URL?.replace(/\/$/, '');

// Registration lives in SwiftBoard. This public-ui page only redirects there.
const Registration = () => {
    useEffect(() => {
        window.location.replace(`${SWIFTBOARD_URL}/register`);
    }, []);

    return (
        <section className="login-section">
            <div className="login-bg-overlay" />
            <div className="login-container" style={{ justifyContent: 'center', textAlign: 'center' }}>
                <div className="login-panel login-panel-left">
                    <span className="btn-spinner" /> Redirecting to registration…
                </div>
            </div>
        </section>
    );
};

export default Registration;
